import script from "./LeadershipView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadershipView.vue?vue&type=script&setup=true&lang=js"

import "./LeadershipView.vue?vue&type=style&index=0&id=0a3c215e&lang=css"

const __exports__ = script;

export default __exports__